export const logisticaTypes = {
    SET_TRANSPORTS: "LOGISTICA_SET_TRANSPORTS",
    SET_CABECERA_FIELD: "LOGISTICA_SET_CABECERA_FIELD",
    SET_CABECERA_FIELDS: "LOGISTICA_SET_CABECERA_FIELDS",
    DESCARTAR_CANDIDATAS: "LOGISTICA_DESCARTAR_CANDIDATAS",
    SET_FILTRO_DOCS_FIELD: "LOGISTICA_SET_FILTRO_DOCS_FIELD",
    LOAD_PLANILLA: "LOGISTICA_LOAD_PLANILLA",
    SET_CANDIDATAS: "LOGISTICA_SET_CANDIDATAS",
    TOGGLE_SELECTED: "LOGISTICA_TOGGLE_SELECTED",
    EDIT_DOCUMENTO_FIELD: "LOGISTICA_EDIT_DOCUMENTO_FIELD",
    SET_BUSCAR_FILTRO_FIELD: "LOGISTICA_SET_BUSCAR_FILTRO_FIELD",
    SET_BUSCAR_RESULTADOS: "LOGISTICA_SET_BUSCAR_RESULTADOS",
    RESET: "LOGISTICA_RESET",
    TOGGLE_DRAWER: "LOGISTICA_TOGGLE_DRAWER",
}
